/** @module Enums */ /** typedoc */

export enum StateUploadingAndSamplingEnum {
    Created = 'Created',
    Uploading = 'Uploading',
    Uploaded = 'Uploaded',
    Sampling = 'Sampling',
    Available = 'Available',
    Failed = 'Failed'
}

export enum StateUploadingAndPreparingEnum {
    Created = 'Created',
    Uploading = 'Uploading',
    Uploaded = 'Uploaded',
    Preparing = 'Preparing',
    Available = 'Available',
    Failed = 'Failed'
}

export enum StateSamplingEnum {
    Created = 'Created',
    Sampling = 'Sampling',
    Available = 'Available',
    Failed = 'Failed'
}

export enum StateMasteringEnum {
    Created = 'Created',
    Mastering = 'Mastering',
    Available = 'Available',
    Failed = 'Failed'
}

export enum StateTranscodingEnum {
    Created = 'Created',
    Transcoding = 'Transcoding',
    Available = 'Available',
    Failed = 'Failed'
}

export enum StatePendingEnum {
    Created = 'Created',
    Pending = 'Pending',
    Available = 'Available',
    Failed = 'Failed'
}
